{
  "loading": "Nalaganje...",
  "placeholder": "Izberite možnost"
}
